import { Header } from "@/components/Landing/Header";
import { Hero } from "@/components/Landing/Hero";
import { Features } from "@/components/Landing/Features";
import { UseCases } from "@/components/Landing/UseCases";
import { FAQ } from "@/components/Landing/FAQ";
import { CTA } from "@/components/Landing/CTA";
import { Footer } from "@/components/Landing/Footer";

const Landing = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white">
      <Header />
      <Hero />
      <Features />
      <UseCases />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
};

export default Landing;